import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import AdvancedCombobox from "../forms/advanced-combobox";

const FilterPopoverDropdown = ({
  filterKey,
  options,
  values,
  onChange,
  multiple,
  searchable,
  allowChangeAll,
  allowUnselectAll,
  width,
}) => {
  const formatted_values = _.map(values, value => ({ value: value, label: value }));
  const [searchText, setSearchText] = React.useState();
  const filtered_options = _.filter(options, option => _.searchCompare(option.label, searchText));

  return (
    <div style={{ width: width || 300 }}>
      <AdvancedCombobox
        options={filtered_options}
        value={formatted_values}
        onChange={values => onChange(filterKey, values)}
        onSearch={setSearchText}
        multiple={multiple}
        searchable={searchable}
        allowChangeAll={allowChangeAll}
        allowUnselectAll={allowUnselectAll}
      />
    </div>
  );
};

FilterPopoverDropdown.propTypes = {
  filterKey: PropTypes.string,
  options: PropTypes.array,
  values: PropTypes.array,
  onChange: PropTypes.func,
  multiple: PropTypes.bool,
  searchable: PropTypes.bool,
  allowChangeAll: PropTypes.bool,
  allowUnselectAll: PropTypes.bool,
  width: PropTypes.number,
};

export default FilterPopoverDropdown;
